import { create } from 'zustand'

export type IBrandDetails = {
  isLinkShared: boolean
  opacityPercent: number
  setIsLinkShared: (payload: boolean) => void
  brandsData: object | null
  setBrandsData: (payload: object | null) => void
  isBrandPageLoading: boolean
  setBrandPageLoading: (payload: boolean) => void
  recommendations: object
  setRecommendations: (payload: object) => void
  userPincode: string
  setUserPincode: (payload: string) => void
  leadId: number | null
  setLeadId: (payload: number | null) => void
  leadSource: 'app' | 'appBrand'
  setLeadSource: (payload: 'app' | 'appBrand') => void
  enBrandVersions: object
  updateBrandVersion: (payload: object, locale: string) => void
  hiBrandVersions: object
  handleResetPincode: boolean
  setHandleResetPincode: (payload: boolean) => void
}

const useBrandStore = create<IBrandDetails>((set, get) => ({
  opacityPercent: 0,
  isLinkShared: false,
  brandsData: null,
  isBrandPageLoading: true,
  recommendations: {},
  userPincode: '',
  leadId: null,
  leadSource: 'appBrand',
  enBrandVersions: {},
  hiBrandVersions: {},
  handleResetPincode: false,
  setIsLinkShared: (payload) => set((state) => ({ isLinkShared: payload })),
  setBrandsData: (payload) => set((state) => ({ brandsData: payload })),
  setBrandPageLoading: (payload) =>
    set((state) => ({ isBrandPageLoading: payload })),
  setRecommendations: (payload) =>
    set((state) => ({ recommendations: payload })),
  setUserPincode: (payload) => set((state) => ({ userPincode: payload })),
  setLeadId: (payload) => set((state) => ({ leadId: payload })),
  setLeadSource: (payload) => set((state) => ({ leadSource: payload })),
  updateBrandVersion: (payload, locale) =>
    set((state) => {
      if (locale === 'en') {
        return {
          enBrandVersions: { ...state.enBrandVersions, ...payload },
        }
      } else {
        return {
          hiBrandVersions: { ...state.hiBrandVersions, ...payload },
        }
      }
    }),
  setHandleResetPincode: (payload) =>
    set((state) => ({ handleResetPincode: payload })),
}))

export default useBrandStore
